import { createReducer } from '@reduxjs/toolkit';

import getOrderInvoice from '../../../thunks/coilovers/orders/getOrderInvoice';
import clearInvoiceView from '../../../actions/coilovers/orders/getOrderInvoice';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const getOrderInvoiceReducer = createReducer(initialState, {
  [getOrderInvoice.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getOrderInvoice.fulfilled]: (state, {
    payload
  }) => ({
    ...state,
    loading: false,
    data: payload,
  }),
  [getOrderInvoice.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [clearInvoiceView]: () => initialState,
});

export default getOrderInvoiceReducer;
